export default __webpack_public_path__ + "static/media/img-soon-4.aa90e687.svg";